import NavigationService from '@lib/NavigationService'

export const navigationSettingAccount = () => {
  NavigationService.navigate('SettingAccount')
}
